import data from "../../.sourceflow/learning_development.json";
import CollectionHelper from "@/helpers/CollectionHelper";

export const learning_helper = new CollectionHelper(data);
